import {STEPPER} from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';

export default function addModelPresentations(currentLang, handleMediaPicker, action) {
    let generalInputs = [
        {
            type: 'text',
            label: 'Nom',
            helper: {
                text: 'Indiquez le nom',
                link: false,
            },
            required: true,
            stateName: 'title',
        },
        {
            type: 'mediaPicker',
            label: 'Image du modèle',
            helper: {
                text: 'Indiquez le nom',
                link: false,
            },
            handleMediaPicker : handleMediaPicker,
            required: true,
            stateName: 'imageModel',
        },
        
    ]
    let children = [
        {
            labelName: 'Paramètres',
            isOptionnal: false,
            optionsInputs: generalInputs
        },
    ];

    var obj = {
        titleForm: action === 'add'? 'Créer un modèle d\'offre':'Modifier un modèle d\'offre',
        subTitleForm: `Veuillez compléter les champs ci-dessous pour ${action === 'add'? 'créer':'modifier'} votre modèle`,
        langSelect: false,
        drawerType: 'drawer',
        noForm: true,
        component: Button,
        formConfig: {
            type: STEPPER,
            finalStep: {
                title: 'Et voilà !',
                subtitle: action === 'add' ? 'Valider la création de ce modèle' : 'Valider la modification de ce modèle',
                textButton: action === 'add' ? 'Créer' : 'Modifier'
            },
            children
        }
    };
    return obj;
}